(function () {
    'use strict';
    var controllerId = 'richAccredProtSent3';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '_', 'datacontext', 'sectionMenu', 'accreditamento', 'isSuper', richAccredProtSent]);

    function richAccredProtSent($scope, $uibModalInstance, _, datacontext, sectionMenu, accreditamento, isSuper) {
        $scope.accreditamento = jQuery.extend({}, accreditamento);
        $scope.isSuper = isSuper;
        $scope.days = 0;

        $scope.minDt = moment($scope.accreditamento.DtRicevuta).startOf('day');
        //$scope.maxDt = moment().startOf('day');
        //console.info('$scope.minDt', $scope.minDt);

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1)
                $scope.opened1 = true;
        };

        $scope.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                $scope.accreditamento.DtProtSent = '';
                $scope.days = 0;
                $scope.changed = true;
            }
        };

        $scope.format = "dd/MM/yyyy";

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.accreditamento);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            return datacontext.cndAccreditamento_setProtSent(item).then(function (data) {
                return data;
            });
        }

    }
})();